import { SkeletonRegistryCategory } from '../../SkeletonRegistryCategory';
import { SkeletonsMultipleChoice } from '../../../../questiontype/MultipleChoice/registry/SkeletonsMultipleChoice';
import { SkeletonsOrderedChoice } from '../../../../questiontype/OrderedChoice/registry/SkeletonsOrderedChoice';
export class SkeletonRegistryQuestionTypes extends SkeletonRegistryCategory {
    label = 'Fragetypen';
    c_multiplechoice = new SkeletonsMultipleChoice(this);
    c_oc = new SkeletonsOrderedChoice(this);
}
